module.exports = __webpack_public_path__ + "@/assets/img/21.582b55ee.jpg";